export const baseStyles = () => {
  return {
    layout: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: 1250,
    },
  };
};
